import axios from 'axios'
// 创建axios实例
const token = window.localStorage.getItem('Admin-Token')

const formflowURL = process.env.VUE_APP_FORM_CENTER_API
const instance = axios.create({
  baseURL: formflowURL,
  timeout: 50000,
  headers: { 'Content-Type': 'application/json;charset=UTF-8' }
})
// axios拦截器
instance.interceptors.request.use(
  config => {
    // 把请求信息给request
    config.headers['Authorization'] = 'Bearer ' + token
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

instance.interceptors.response.use(
  response => {
    // 返回拦截结果，否则请求中拿不到成功数据
    return response.data
  },
  err => {
    return Promise.reject(err)
  }
)
export default instance
